export const REGEX_BETWEEN_PARENS = /\(([^)]+)\)/;

